/** LeadSourcesRoute — skin-aware switcher for /lead-sources. */
import { useUISkin } from "@/data/UISkinContext";
import LeadSources from "./LeadSources";
import { CockpitFrame } from "@/components/cockpit/CockpitFrame";

export default function LeadSourcesRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") {
    return (
      <CockpitFrame eyebrow="Marketing · Sources" title="Lead Sources">
        <LeadSources />
      </CockpitFrame>
    );
  }
  return <LeadSources />;
}
